/*
 * hide-zentaii.js
 *
 * Hides the brand word "zentaii" in product cards, PDP titles,
 * cart titles, and search result titles.
 * Operates on the visual layer only (client-side text replacement).
 */
(function () {
  'use strict';

  // Match "zentaii" as a whole word, case-insensitive, with any directly
  // adjacent whitespace so we don't leave double spaces behind.
  var WORD_RE = /\s*\bzentaii\b\s*/gi;

  var TITLE_SELECTORS = [
    '.product__title',
    '.product-single__title',
    '.product-title',
    '.card__heading',
    '.card__heading a',
    '.card-information__text',
    '.cart-item__name',
    '.cart-notification-product__name',
    '.predictive-search__item-heading',
    '.predictive-search-item__heading',
    '[data-product-title]',
    '[data-product-name]'
  ].join(',');

  function clean(text) {
    if (!text || text.indexOf('zentaii') === -1 && text.indexOf('Zentaii') === -1 && text.indexOf('ZENTAII') === -1) {
      // Quick reject: avoid the regex if the word isn't present at all.
      return text;
    }
    // Replace and collapse any whitespace runs introduced by the removal.
    var next = text.replace(WORD_RE, ' ').replace(/\s{2,}/g, ' ').trim();
    return next;
  }

  function scrubElement(el) {
    if (!el || el.dataset.zentaiiScrubbed === '1') return;

    // Walk only direct text nodes so we don't touch nested badges/buttons.
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    var changed = false;
    while ((node = walker.nextNode())) {
      var original = node.nodeValue;
      var updated = clean(original);
      if (updated !== original) {
        node.nodeValue = updated;
        changed = true;
      }
    }

    if (changed) {
      el.dataset.zentaiiScrubbed = '1';
    }
  }

  function scrub(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(TITLE_SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      // Reset the scrubbed flag if the node's text changed since last pass
      // (e.g. variant change replacing innerHTML).
      delete nodes[i].dataset.zentaiiScrubbed;
      scrubElement(nodes[i]);
    }
  }

  function init() {
    scrub(document);

    // Watch for dynamic updates (cards, cart, and predictive search).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var added = m.addedNodes[j];
            if (added.nodeType === 1) scrub(added);
          }
        } else if (m.type === 'characterData' && m.target.parentNode) {
          var parent = m.target.parentNode.closest && m.target.parentNode.closest(TITLE_SELECTORS);
          if (parent) {
            delete parent.dataset.zentaiiScrubbed;
            scrubElement(parent);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
